import { DURATION_LABEL_KEYS } from "../constants/layout";
import { BUNDLE_TYPE_ID, CONFIGURABLE_TYPE_ID, DIGITAL24SKUS, DURATION_MATCHING, DURATION_SPAN_BIENNIAL, DURATION_SPAN_HALFYEARLY, DURATION_SPAN_MONTHLY, DURATION_SPAN_QUARTERLY, DURATION_SPAN_YEARLY, IN_STOCK, NO_CONSEGNA, NOT_PHYSICAL, OUT_OF_STOCK, PHYSICAL, SIMPLE_TYPE_ID, SUBSCRIPTION_DEFAULT_BILLING_PERIOD, TIPO_RINNOVO_AUTOMATICO, VIRTUAL_TYPE_ID } from "../constants/product";
import { getStoreCodeForRequests } from "../solepro/functions";
import axios from "axios";
import GET_PRODUCT_EXTENDED_DATAS from '../../modules/catalog/product/queries/getProductExtendedDatas.gql';
import { isEmpty } from 'lodash-es';
import { BRIGHTCOVE_POLICY_KEY } from "../constants/code";

export const getPriceFields = product => {
  return product.type_id == VIRTUAL_TYPE_ID ? {
    full: ['full_price'],
    promotional: ['promotional_price'],
    discounted: ['discounted_price']
  } : {
    full: ['full_price_low', 'full_price_high', 'full_price'],
    promotional: ['promotional_price_low', 'promotional_price_high', 'promotional_price'],
    discounted: ['discounted_price_low', 'discounted_price_high', 'discounted_price']
  }
}


export const getDurationLabel = (durationQty, durationSpan, i18n) => {
  switch (durationSpan) {
    case DURATION_SPAN_MONTHLY: return i18n.tc('month', durationQty);
    case DURATION_SPAN_QUARTERLY: return i18n.tc('quarter', durationQty);
    case DURATION_SPAN_HALFYEARLY: return i18n.tc('semester', durationQty);
    case DURATION_SPAN_YEARLY: return i18n.tc('year', durationQty);
    case DURATION_SPAN_BIENNIAL: return i18n.tc('biennium', durationQty);
  }
}

export const getNotBundlePaymentFrequencies = (product, retrieveUids) => {
  if (product.type_id == SIMPLE_TYPE_ID || product.type_id == VIRTUAL_TYPE_ID) { return { frequencies: [DURATION_MATCHING[product.tipo_abbonamento]] }; }
  else if (product.type_id == CONFIGURABLE_TYPE_ID) {
    const pf = [...new Set(product.variants.map(v => DURATION_MATCHING[v.product.tipo_abbonamento]).sort())]; //removing duplicates
    if (retrieveUids || product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento') == undefined) {
      return { frequencies: pf };
    } else {
      return {
        frequencies: pf,
        uids: product.configurable_options.find(el => el.attribute_code == 'tipo_abbonamento').values.map(val => val.uid)
      }
    }
  }
  else return null;
}

const hasTipoAbbonamentoOption = opt => !!opt.product.configurable_options.find(co => co.attribute_code == 'tipo_abbonamento');
export const getBundleFirstConfigurableWithOptions = bundle => {
  try {
    return bundle.items.find(el =>
      /* configurables sections*/el.options_type == 'configurabili'
      /*having options*/ && !!el.options && el.options.length > 0
      /*and there is tipo_abbonamwnto in those options*/ && el.options.find(hasTipoAbbonamentoOption))
    /**returning that configurable product */.options.filter(hasTipoAbbonamentoOption)[0].product
  } catch (e) {
    console.warn('This bundle has no configurable products with tipo_abbonamento options');
    return;
  }
}
export const getBundlePaymentFrequencies = (product, retrieveUids) => {
  try {
    const firstConfigurable = (product.type_id == 'bundle') ? getBundleFirstConfigurableWithOptions(product) : product;
    if (!firstConfigurable) {
      /**Check for tipo_abbonamento on first configurable product variants, this is a security double check */
      return getNotBundlePaymentFrequencies(product.items.find(el => el.options_type == 'configurabili').options[0].product, retrieveUids)
    } else if (!firstConfigurable.configurable_options) {
      return getNotBundlePaymentFrequencies(product, retrieveUids)
    }
    const matchedVariants = product && product.items && product.items.flatMap(item => {
      if (item.options_type && item.options && item.options[0].product && item.options[0].product.variants) {
        const variants = item.options[0].product.variants;
        const prices = item.options[0].configurable_options_prices || [];

        return variants
          .filter(variant => prices.some(price => price.configurable_option_id == variant.product.id))
          .map(variant => variant.product);
      }
      return {};
    });

    const tipoAbbonamentoOptions = firstConfigurable.configurable_options.find(a => a.attribute_code == 'tipo_abbonamento');

    if (tipoAbbonamentoOptions) {
      const filteredValues = matchedVariants && tipoAbbonamentoOptions.values.filter(el => matchedVariants.some(val => val.tipo_abbonamento == el.value_index));
      const pf = matchedVariants && matchedVariants.length > 0 ? filteredValues.map(el => DURATION_MATCHING[el.value_index]).sort() : tipoAbbonamentoOptions.values.map(el => DURATION_MATCHING[el.value_index]).sort();

      if (retrieveUids) {
        return {
          frequencies: pf,
          uids: tipoAbbonamentoOptions.values.map(el => el.uid)
        }
      } else {
        return { frequencies: pf };
      }
    }
  } catch (e) {
    return { error: e }
  }
}


export const getPaymentFrequencies = (product, retrieveUids) => {
  const pfNotBundle = getNotBundlePaymentFrequencies(product, retrieveUids);
  return pfNotBundle ? pfNotBundle : getBundlePaymentFrequencies(product, retrieveUids);
}

export const getFirstPriceLabel = (product, span, i18n, $fc, $shippingPrice = 0, discountedShippingPrice = 0) => {
  //If no promotional price but shippingPrice exists then set it to 0 so we can work with it
  if (!product.promotional[span] && $shippingPrice > 0) {
    product.promotional[span] = { duration: 1, price: 0 };
  }
  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan) || product.forceShowTrialInEachPriceSection);
  //const i18n = useI18n(); error on getting vue instance @TODO check why
  /**  TRIAL */
  if (isCurrentPlanTrial) {
    return i18n.tc("{durationQty} {duration} of trial at {trialPrice}", product.trialPrice, {
      durationQty: product.trialDuration,
      duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
      trialPrice: $fc(product.trialPrice + $shippingPrice)
    }) as String;
  } else if (product.promotional[span]) {
    /** PROMOTIONAL */
    if (product.promotional[span].price < product.prices[span]) {
      return i18n.t("{durationQty} {duration} at {price} {discountedPrice}", {
        durationQty: product.promotional[span].duration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
        price: $fc(product.prices[span] + discountedShippingPrice),
        discountedPrice: $fc(product.promotional[span].price + $shippingPrice)
      }) as String
    } else if (product.startupCost) {
      return i18n.t("{price} first {duration}(included {startup})", {
        price: $fc(product.promotional[span].price + discountedShippingPrice),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
        startup: $fc(product.startupCost)
      })
    } else {
      return i18n.t("{durationQty} {duration} at {discountedPrice}", {
        durationQty: product.promotional[span].duration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
        discountedPrice: $fc(product.promotional[span].price + $shippingPrice)
      }) as String
    }
  } else if (product.discountedPrices[span]) {
    /**  DISCOUNTED */
    return i18n.tc("discounted {price} {discountedPrice} each {durationQty} {duration}", 1, {
      price: $fc(product.prices[span] + discountedShippingPrice),
      discountedPrice: $fc(product.discountedPrices[span] + $shippingPrice),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
    }) as String

  } else {
    /** STANDARD */
    return i18n.tc("{price} / each {durationQty} {duration}", 1, {
      price: $fc(product.prices[span] + $shippingPrice),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String;

  }
}

export const getSecondPriceLabel = (product, span, i18n, $fc, $shippingPrice = 0, discountedShippingPrice = 0) => {
  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan) || product.forceShowTrialInEachPriceSection);
  //If no promotional price but shippingPrice exists then set it to 0 so we can work with it
  if (!product.promotional[span] && $shippingPrice > 0) {
    product.promotional[span] = { duration: 1, price: 0 };
  }
  if (product.prices[span] === undefined) {
    product.prices[span] = 0;
  }
  //const i18n = useI18n(); error on getting vue instance @TODO check why
  if (isCurrentPlanTrial || product.promotional[span] || product.forceShowTrialInEachPriceSection) {
    if (product.promotional[span]) {
      const promotionalString = i18n.tc("{price} / trial {durationQty} {duration}", product.promotional[span].duration, {
        price: $fc(product.promotional[span].price + discountedShippingPrice),
        durationQty: product.promotional[span].duration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
      });
      const priceString = product.discountedPrices[span] && product.discountedPrices[span] < product.prices[span] ?
        i18n.tc("discounted {price} {discountedPrice} each {durationQty} {duration}", 1, {
          price: $fc(product.prices[span] + discountedShippingPrice),
          discountedPrice: $fc(product.discountedPrices[span] + $shippingPrice),
          durationQty: 1, duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        }) as String
        : i18n.tc("{price} / each {durationQty} {duration}", 1, {
          price: $fc(product.prices[span] + $shippingPrice),
          durationQty: 1, duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        }) as String
      return i18n.t("then {promotionalString} and then {priceString}", { promotionalString, priceString }) as String
    } else if (product.discountedPrices[span]) {
      return i18n.tc("then {price} {discountedPrice} / {durationQty} {duration}", 1, {
        price: $fc(product.prices[span] + discountedShippingPrice),
        discountedPrice: $fc(product.discountedPrices[span] + $shippingPrice),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        durationQty: 1
      }) as String;
    } else {
      return i18n.t("then {price} / {duration}", {
        price: $fc(product.prices[span] + $shippingPrice),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
      }) as String;
    }
  }
  return null;
}

/** Used to mange collapsed price */
/** Promotional price and discounted price have the same label */
export const getAdditionalPriceLabel = (product, span, i18n, $fc) => {
  span = span ? span : product.trialDurationSpan;
  if (product.promotional[span]) {
    return i18n.t("or {price} {discounted} / {duration}", {
      discounted: $fc(product.promotional[span].price),
      price: $fc(product.prices[span]),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String

  } else if (product.discountedPrices[span]) {
    return i18n.t("or {price} {discounted} / {duration}", {
      discounted: $fc(product.discountedPrices[span]),
      price: $fc(product.prices[span]),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String
  } else {
    return i18n.t("or {price} / {duration}", {
      price: $fc(product.prices[span]),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String;
  }

}

export const getOptionsForSelections = product => {

  if (product.type_id == CONFIGURABLE_TYPE_ID) {
    const optionBlocks = [];
    /**
     * Excluding tipo_abbonamento because it's managed by the ProductFrequencySwitcher
     * Excluding tipo_cnsegna because it's managed by the PriductAddPaperCheckbox
     * @TODO manage options for all types of options in solepro (like natura if books have to be sell)
     */
    const attributesToExclude = ['tipo_abbonamento', 'tipo_consegna']
    /** Foreach selectable configuration we will map uids and attribute infos */
    product.configurable_product_options_selection.options_available_for_selection.filter(el => !attributesToExclude.includes(el.attribute_code)).forEach(selectable => {
      const configurableOptions = product.configurable_options.find(opt => opt.attribute_code == selectable.attribute_code);
      const optionValues = selectable.option_value_uids.map(uid => Object.assign({}, configurableOptions.values.find(val => val.uid == uid)))
      optionValues.forEach((opt, i) => {

        const variant = product.variants.find(variant => {
          const optionObj = variant.product[configurableOptions.attribute_code] /** during the product manipulation we have tipo_consegna as {label , value} so we have to manage this kind of structure @TODO optimize, ugly, we should have the clean product */
          return (optionObj.value ?? optionObj) == opt.value_index
        }).product
        optionValues[i].cost = variant.price_range.maximum_price.final_price.value;
      })



      if (optionValues.length > 0) {
        optionBlocks.push({
          attribute_code: configurableOptions.attribute_code,
          attribute_id: configurableOptions.attribute_id,
          attribute_uid: configurableOptions.uid,
          options: optionValues
        })
      }
    })
    return optionBlocks;

  } else return null
}

export const getHasPaperToAdd = (configurableProducts, tipoConsegnaValues) => {
  let hasPaperToAdd = false;
  /**
   * Check if there are products available for shipping @TODO check if this is the condition!
   */
  configurableProducts.forEach((p, pindex) => {
    if (!p.variants) return;
    p.variants.forEach((variant, vindex) => {
      const tipoConsegnaValue = variant.product.tipo_consegna;
      configurableProducts[pindex].variants[vindex].product.tipo_consegna = {/** check if this is necessary or if it has to move in other fn */
        value: tipoConsegnaValue,
        label: tipoConsegnaValues[tipoConsegnaValue]
      };
      if (!!tipoConsegnaValue && !NO_CONSEGNA.includes(tipoConsegnaValue)) hasPaperToAdd = true;
    });
  });
  return hasPaperToAdd;
};

export const getPaperOptions = (hasPaperToAdd, configurableProducts) => {
  if (!hasPaperToAdd) return [];
  return configurableProducts.filter((p, pindex) => {
    if (!p.variants) return false;
    return !!p.configurable_options.find(opt => opt.attribute_code == 'tipo_consegna' && (opt.values.map(el => el.value_index)).every(val => !NO_CONSEGNA.includes(val)))
  })

}

export const getModuleDatas = (items, tipoConsegnaValues) => {
  /** Exclude "aggiungi versione cartacea" because is an option managed by the checkbox and not in the modules list
   *  Exclude digital version because is managed by 
   * for that item required==true min&max opt in cart == 0*/
  const verticalOptions = items.filter((item) => item.options_type === "verticals");
  const configurableOptions = items.filter((item) => item.options_type === "configurabili");
  const otherOptions = items.filter((item) => item.options_type === "other");
  const choosableModules = verticalOptions.filter(item => item.max_options_in_cart > 0 && item.options.length > item.min_options_in_cart);
  const modules = choosableModules.map(el => el.options).flat().filter(el => !el.is_default);
  let hasDigitalSole24H = false;
  const requiredConfigurables = configurableOptions.filter(item =>
    item.required && (item.min_options_in_cart == item.max_options_in_cart && (item.min_options_in_cart == 0 || item.min_options_in_cart == item.options.length))
  ).map(el => el.options)
    .flat()
    .filter(mod => {
      /*exclude sole 24 digital @TODO check if to get from magento */
      const isDigital24H = DIGITAL24SKUS.includes(mod.product.sku)
      if (isDigital24H) hasDigitalSole24H = true;
      return !isDigital24H
    }
    )
  const requiredVerticals = verticalOptions.filter(item =>
    item.required && (item.min_options_in_cart === item.max_options_in_cart && (item.min_options_in_cart === 0 || item.min_options_in_cart === item.options.length))
  ).map(el => el.options).flat();

  const requiredOthers = otherOptions.map(el => el.options).flat();
  const requiredInChoosable = choosableModules.map(el => el.options).flat().filter(el => el.is_default);

  const requiredModules = [...requiredVerticals, ...requiredConfigurables, ...requiredInChoosable, ...requiredOthers];
  const configurableProducts = [...items.filter(el => el.type_id == CONFIGURABLE_TYPE_ID), ...items.filter(el => el.options_type == 'configurabili').map(el => el.options).flat().map(el => el.product)];


  return {
    modulesInCartQty: choosableModules.length == 1 ? { // When there are modules to choose, there is only one optional module
      min: choosableModules[0].min_options_in_cart - requiredInChoosable.length,
      max: choosableModules[0].max_options_in_cart - requiredInChoosable.length,
    } : null,
    configurableProducts,
    hasPaperToAdd: getHasPaperToAdd(configurableProducts, tipoConsegnaValues),
    hasDigitalSole24H,
    modules,
    requiredModules
  }
}

/**
 * At this time the promotional duration is always one
 */
export const getPromotionalPrices = (product, paymentFrequencies, priceFields) => {
  /** Check if at least one of the discounted price fields is populated */
  if (priceFields.some(priceField => product[priceField])) {
    let prices = {};
    /**
    * At this time the promotional duration is always one
    */
    prices = getPrices(product, paymentFrequencies, priceFields)
    Object.keys(prices).forEach((key) => { prices[key] = { duration: 1, price: prices[key] } });

    return prices;
  }
  return {};
}

/**
 * If there is only one payment frequency :
 *      Y -> *_price_high
 *      Q -> *_price_high
 *      M -> *_price_low
 */
export const getPrices = (product, paymentFrequencies, priceFields, productAttributes = {}) => {

  /** @TODO THIS MUST BE MANAGED BY CONSTANT KEYS, NOT HERE */
  const biennialKey = Object.keys(productAttributes).find(key => productAttributes[key] == 'Biennale');
  const isBiennial = biennialKey && product && product.entry_billing_period && product.entry_billing_period == biennialKey;
  let prices = {};
  if (product[priceFields[0]] || product[priceFields[1]]) {
    if (paymentFrequencies.length === 1) {
      priceFields = paymentFrequencies[0] === 'M'
        ? [priceFields[0]]
        : product.type_id === BUNDLE_TYPE_ID || product.type_id === CONFIGURABLE_TYPE_ID
          ? [priceFields[priceFields.length - 2]]
          : (priceFields[priceFields.length - 1] > 0 ? [priceFields[priceFields.length - 1]] : [priceFields[priceFields.length - 1]]); //@TODO check for virtuals
    }

    (paymentFrequencies || []).forEach((pf, index) => {
      if (!!product[priceFields[index]]) {
        prices[pf] = product[priceFields[index]];
      }
    });
  } else if (!priceFields[0].includes('discounted') && product.type_id != CONFIGURABLE_TYPE_ID) {
    prices[paymentFrequencies[0]] = product?.price_range?.maximum_price?.final_price.value ?? product.discounted_price_posta;
  } else { prices = {} }
  /** @TODO THIS MUST BE MANAGED BY CONSTANT KEYS, NOT HERE */
  if (isBiennial) {
    const currentKey = Object.keys(prices)[0];
    if (currentKey && currentKey !== 'B') {

      const value = prices[currentKey];
      delete prices[currentKey];
      prices['B'] = value;
    }
  }
  return prices;
};


export const getFirstProLabel = (product, span, i18n, $fc, $shippingPrice = 0, usePriceLabelFrom = true) => {

  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan));
  const { product: firstVariant, lowestVariantPrice } = getLowestPricedVariant(product) || {};
  const lowestParentPrice = getLowestParentPrice(product, span);

  /**
   * @explanation
   * Trial will override all the logic after, because if it's trial, then just show it.
   * @todo: Should handle Bundles a partire da.
  */

  if (isCurrentPlanTrial) {

    /** Variants present, so alter the string in order to show a partire da: */
    if (firstVariant) {
      return i18n.tc(`${usePriceLabelFrom ? 'from ' : ''}{durationQty} {duration} of trial at {trialPrice}`, product.trialPrice, {
        durationQty: product.trialDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
        trialPrice: $fc(product.trialPrice + $shippingPrice)
      }) as String;
    }

    /** No variants found, let's show normal string. */
    else {
      return i18n.tc("{durationQty} {duration} of trial at {trialPrice}", product.trialPrice, {
        durationQty: product.trialDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
        trialPrice: $fc(product.trialPrice + $shippingPrice)
      }) as String;
    }

  }

  /** 
   * @explanation
   * This is when a demoDuration is provided, like no checkout phase is required.
   * Internalization and pluralization is used to handle different values and string.
  */

  else if (product.demoDuration && product.demoDurationSpan) {

    return i18n.tc("{durationQty} {duration} of free trial", product.demoDuration, {
      durationQty: product.demoDuration,
      duration: i18n.tc(DURATION_LABEL_KEYS[product.demoDurationSpan], product.demoDuration),
    }) as String;

  }




  /** 
   * @explanation
   * This will work with one-shot startup software product
   * If startUp is present, we shoul care about promotional, because the string will be incorrect.
   * So, if promotional is not present, then should not display the product.
   * I'm not aware about discounted one, but for the moment i'll let like this.
   * If problems arise we will fix it.
   * @todo: Check startUp different situation when URLRewrites will be fixed.
  */

  else if (product.startupCost && product.promotional[span]?.price) {
    return i18n.t("{price} first {duration}(included {startup})", {
      price: $fc(product.promotional[span].price + $shippingPrice),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], product.promotional[span].duration),
      startup: $fc(product.startupCost)
    })
  }
  /** Variants present, so alter the string in order to show a partire da: */
  else if (firstVariant) {
    return i18n.t(`${usePriceLabelFrom ? 'from ' : ''}{price} / {duration}`, {
      price: $fc(firstVariant.product.price_range.maximum_price.final_price.value + $shippingPrice),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String;
  }

  /**
   * @explanation
   * If a lowestParentPrice exists, it means that there is a bundle/virtual.
   * I saw that with configurables no prices are provided inside data model, that should be a fix that we can made.
   * if no variant is present, then is a one-shot without "A partire da.."
  */

  else if (lowestParentPrice) {

    /** Bundles case, will get the lowest price avoiding check if it's promotional or not. */
    if (lowestParentPrice && firstVariant) {
      return i18n.t(`${usePriceLabelFrom ? 'from ' : ''}{price} / {duration}`, {
        price: $fc(lowestParentPrice + $shippingPrice),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
      }) as String;
    }

    /** One-shots case, will get the lowest price avoiding check if it's promotional or not. */
    else {
      return i18n.t(`${usePriceLabelFrom ? 'from ' : ''}{price} / {duration}`, {
        price: $fc(lowestParentPrice + $shippingPrice),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
      }) as String;
    }

  }

  /** 
   * @explanation
   * In case of configurables, prices are not shown inside the parent, because a choice needs to be made.
   * Then we should check if there is a lowest variant that we can get, and fetch specific prices from it.
   * Same logic as above will be done, but in a lower level and with different properties. (Variant have different props.)
   * Here the label "A partire da.." is required, because there are several options to be aware of.
   * @todo: Check startUp different situation when URLRewrites will be fixed.
  */

  else if (firstVariant && !lowestParentPrice) {
    const { product: { startup_cost, tipo_abbonamento, promotional_price } } = firstVariant || {};
    const duration = i18n.tc(DURATION_LABEL_KEYS[DURATION_MATCHING[tipo_abbonamento]], 1);

    /** If start-up cost exist, then use it before the others. */
    if (startup_cost && promotional_price) {
      return i18n.t(`${usePriceLabelFrom ? 'from ' : 'notfrom '}from {price} first {duration}(included {startup})`, {
        price: $fc(promotional_price),
        duration,
        startup: $fc(startup_cost)
      });
    }

    /** Just get the lowestVariantPrice and display it with a partire da: */
    else if (lowestVariantPrice) {
      return i18n.t(`${usePriceLabelFrom ? 'from ' : ''}{price} / {duration}`, {
        price: $fc(lowestVariantPrice),
        duration
      }) as String;
    }

  }

}

export const getSecondProLabel = (product, span, i18n, $fc, usePriceLabelFrom = true) => {

  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan));
  const { product: firstVariant, lowestVariantPrice } = getLowestPricedVariant(product) || {};
  const lowestParentPrice = getLowestParentPrice(product, span);

  /**
   * @explanation
   * Removed all the whole logic related to display discounted/promotional price.
   * If will be required again inside UX/UI, then we will re-introduce the logic of discounted/promotional.
  */

  if (isCurrentPlanTrial) {
    return i18n.t("then {price} / {duration}", {
      price: $fc(lowestParentPrice),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String;
  }

  /** 
   * @todo: Insert logic for demo-attributes.
  */

  else if (product.startupCost) {
    return i18n.t("then {price} / {duration}", {
      price: $fc(lowestParentPrice),
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
    })
  }

  /** 
   * @explanation
   * If no options are found inside the parent we can fall-back on the childrens.
   * This is to render A seguire prices in a correct way.
  */

  else if (firstVariant && !lowestParentPrice) {

    const { product: { tipo_abbonamento, startup_cost } } = firstVariant || {};
    const duration = i18n.tc(DURATION_LABEL_KEYS[DURATION_MATCHING[tipo_abbonamento]], 1);

    /** If start-up cost exist, then use it before the others. */
    if (startup_cost) {
      return i18n.t("then {price} / {duration}", {
        price: $fc(lowestVariantPrice),
        duration
      });
    }

    /**
     * @explanation
     * Here if i render again the lowest price, then will be repeated as the first string.
     * The only thing that we can do is re-use the previous logic in order to render discounted/promotional string.
     * But only if it's required, and we will see it during the UAT's.
     */

    else {
      return ''
    }

  }

  return null;
}

/**
 * Getting First label for books.
 * @todo: Maybe use variants and product type, like simple or virtual to find better solution.
 * @todo: Books bundle NOT included for the moment.
 * @param product 
 * @param i18n 
 * @param $fc 
 */
export const getFirstBookLabel = (product, i18n) => {

  const optionsToSelect = product?.variants || [];
  const hasCartaceo = optionsToSelect.some(({ product }) => product.type_id == SIMPLE_TYPE_ID);
  const hasDigitale = optionsToSelect.some(({ product }) => product.type_id == VIRTUAL_TYPE_ID);

  // In case of simple book, remember to insert bundle when they will decide.
  if (optionsToSelect.length == 0) return product?.price;

  if (hasCartaceo && hasDigitale) {
    return i18n.t('Available in format {format_1} or {format_2}', {
      format_1: PHYSICAL,
      format_2: NOT_PHYSICAL
    });
  }

  if (hasCartaceo) {
    return i18n.t('Available in format {format}', {
      format: PHYSICAL
    });
  }

  if (hasDigitale) {
    return i18n.t('Available in format {format}', {
      format: NOT_PHYSICAL
    });
  }

  return null;

}

/**
 * Function to get the price of a Bundle <Not for the moment>, Configurable or Simple Book.
 * Will display the lowest price available inside the product.
 * @param product
 * @param i18n 
 * @param $fc 
 */

export const getSecondBookLabel = (product, i18n, $fc, usePriceLabelFrom = true) => {
  const { variants = [] } = product || {};

  if (!Array.isArray(variants) || variants.length === 0) {
    let price = product?.price;
    if (product.prices && Object.keys(product.prices).length == 1) {
      price = Object.values(product.prices)[0]
      const duration = i18n.tc(DURATION_LABEL_KEYS[Object.keys(product.prices)[0]], 1);
      return i18n.t(`{price} / {duration}`, { price: $fc(price), duration })
    }
    return i18n.t(`${usePriceLabelFrom ? 'From ' : 'Notfrom '}{price}`, {
      price: $fc(price ?? 0)
    });
  }

  const cheapestVariant = variants.reduce((cheapest, current) => {
    const currentPrice = current?.product?.price_range?.minimum_price?.final_price?.value ?? Infinity;
    const cheapestPrice = cheapest?.product?.price_range?.minimum_price?.final_price?.value ?? Infinity;
    return currentPrice < cheapestPrice ? current : cheapest;
  });

  return i18n.t(`${usePriceLabelFrom ? 'From ' : 'Notfrom '}{price}`, {
    price: $fc(cheapestVariant?.product?.price_range?.minimum_price?.final_price?.value ?? 0)
  });

}

/**
 * Function to get the lowest price product for Meta PDP.
 * Useful for meta-pdp product.
 * @param products 
 * @returns 
 */
export const getLowestMetaPrice = (products) => {
  return products.reduce((lowest, current) => {

    const currentSpan = current.paymentFrequencies[0];
    const currentMin = Math.min(
      current.prices?.[currentSpan] ?? Infinity,
      current.discountedPrices?.[currentSpan] ?? Infinity,
      current.promotionalPrices?.[currentSpan] ?? Infinity
    );

    const lowestSpan = lowest.paymentFrequencies[0];
    const lowestMin = Math.min(
      lowest.prices?.[lowestSpan] ?? Infinity,
      lowest.discountedPrices?.[lowestSpan] ?? Infinity,
      lowest.promotionalPrices?.[lowestSpan] ?? Infinity
    );

    return currentMin < lowestMin ? current : lowest;
  });
}

/**
 * Function to get the lowest price based on different attributes inside the parent.
 * Useful for configurables and bundle products.
 * @param product
 * @param span
 * @returns 
 */

export const getLowestParentPrice = (product, span) => {
  const { prices = {}, discountedPrices = {}, promotional = {} } = product || {};

  const price = prices?.[span] ?? Infinity;
  const discountedPrice = discountedPrices?.[span] ?? Infinity;
  const promotionalPrice = promotional?.[span]?.price ?? Infinity;

  const lowestPrice = Math.min(price, discountedPrice, promotionalPrice);

  return lowestPrice === Infinity ? null : lowestPrice;
};

/**
 * Function to get the lowest priced variant based on different attributes.
 * Useful when no values are returned from the parend and we should fallback to the variants.
 * @param products 
 * @returns 
 */

export const getLowestPricedVariant = (products) => {

  const { variants = [] } = products || {};

  if (variants.length > 0) {
    return variants.reduce((lowestProduct, currentProduct) => {
      const { price_range, discounted_price, promotional_price, full_price } = currentProduct.product;

      const minPrice = price_range?.minimum_price?.final_price?.value || null;
      const discountPrice = discounted_price || null;
      const promoPrice = promotional_price || null;
      const fullPrice = full_price || null;

      const currentLowestPrice = [minPrice, discountPrice, promoPrice, fullPrice]
        .filter((price) => price != null) // Filtra valori null
        .reduce((min, price) => (price < min ? price : min), Infinity);

      if (!lowestProduct || (currentLowestPrice != null && currentLowestPrice < lowestProduct.lowestVariantPrice)) {
        return { product: currentProduct, lowestVariantPrice: currentLowestPrice };
      }

      return lowestProduct;
    }, null);

  } else {
    return null
  }
};


export const getOptionsBlock = (product) => {
  if (!product) return []
  let opts = []
  if (product.typeId == CONFIGURABLE_TYPE_ID) {
    return product.configurable_options.map(opt => {
      return {
        attribute_code: opt.attribute_code,
        attribute_id: opt.attribute_id,
        attribute_uid: opt.attribute_uid,
        options: opt.values.map(el => {
          let variant = product.variants.find(v => v.product[opt.attribute_code] == el.value_index)
          if (!variant) variant = product.variants.find(v => v.product[opt.attribute_code].value == el.value_index) // @TODO check the first line if can be removed
          return {
            ...el,
            //box_description:variant?.product.box_description,
            outOfStock: variant?.product.stock_status == OUT_OF_STOCK,
            cost: variant?.product.price_range.maximum_price.final_price.value
          }
        }).filter(el => !!el.cost)

      }
    }).filter(el => el.options.length > 0 && el.attribute_code !== 'tipo_abbonamento')
  } else if (product.optionsToSelect && product.optionsToSelect.length > 0) {
    opts = product.optionsToSelect
  }
  return opts
}
export const getProductExtendedDatas = async (req, graphQLApiEndpoint, sku) => {
  const graphqlQuery = {
    operationName: "getProductExtendedDatas",
    query: GET_PRODUCT_EXTENDED_DATAS,
    variables: {
      filter: { sku: { eq: sku } }
    },
  };
  let storeCode = getStoreCodeForRequests(req)
      const headers = {
        "content-type": "application/json",
        "store": storeCode
      };
    const resp = await axios({
      url: graphQLApiEndpoint,
      method: "post",
      headers,
      data: graphqlQuery,
    });
    try {
      if (resp.data.data.products.items.length > 0) {
        return(resp.data.data.products.items[0])
      } else {
        console.warn(`FN getProductExtendedDatas/:${sku}`, 'MMMM it seems ther is no product with this sku. Strange.')
        return {items:[]}
      }
    } catch (e) {
      const message = `Catched error getting FN /pro/getProductExtendedDatas/:sku ${sku}`;
      console.error(message)
      console.error(e)
      return false
    }
}

const isBundle = product => {
  return product?.type_id == 'bundle' || product?.typeId == 'bundle'
}
const formatConfigurableOptions = (configurable_options, variants) => {
  if (!configurable_options) return configurable_options
  configurable_options.forEach((co, ci) => {
    co.values.map(v => {
      v.label = v.label.replace(/formato /ig, '')
      return v
    })
    const indexes = variants.map(el => el.product[co.attribute_code].value || el.product[co.attribute_code] );
    const ordered = indexes.map(i => co.values.find(v => v.value_index == i))
    configurable_options[ci].values = ordered
  })
  return configurable_options;
}
export const composeProductForGetProduct = (product, extendedDatas, attributeSets, entityCheck, productAttributes) => {
  product = { ...product, ...extendedDatas };
  const pfs = getPaymentFrequencies(product, true);

  const paymentFrequencies = pfs?.frequencies;
  const paymentFrequenciesUids = pfs?.uids;
  if (pfs&&pfs['error']) {
    return {error: pfs['error']}
  }
  const items = isBundle(product) ? product.items : [product]
  const configurableProducts = product.type_id == 'bundle' ? items.filter(el => el.options_type == 'configurabili').map(el => el.options).flat().map(el => el.product) : [product];
  const modulesData = getModuleDatas(product.type_id == 'bundle' ? product.items : [product], productAttributes['tipo_consegna'])
  const paperOptions = getPaperOptions(modulesData.hasPaperToAdd, configurableProducts);
  const priceFields = getPriceFields(product);

  const paymentFrequenciesObj = paymentFrequencies ?? pfs;

  let entryBillingPeriodValue = 'Y';

  if (product.entry_billing_period === null) {
    if (product.tipo_abbonamento === null) {
      entryBillingPeriodValue = 'Y';
    } else {
      entryBillingPeriodValue = SUBSCRIPTION_DEFAULT_BILLING_PERIOD[productAttributes['tipo_abbonamento'][product.tipo_abbonamento]];
    }
  } else {
    entryBillingPeriodValue = SUBSCRIPTION_DEFAULT_BILLING_PERIOD[productAttributes['entry_billing_period'][product.entry_billing_period]];
  }
  let offerGroups = product.offer_groups;
  try {
    offerGroups = JSON.parse(product.offer_groups)
  } catch (e) { }

  return {
    sku: product.sku,
    name: product.name,
    zuoraId: product.zuora_id,
    subtitle: product.sub_description_1,
    paymentFrequencies: paymentFrequenciesObj,
    price: !paymentFrequenciesObj || paymentFrequenciesObj.length < 1 ? product.price_range.maximum_price.final_price.value : null,
    prices: getPrices(product, paymentFrequenciesObj, priceFields.full),
    promotional: getPromotionalPrices(product, paymentFrequenciesObj, priceFields.promotional),//empty object if there are no promotions
    discountedPrices: getPrices(product, paymentFrequenciesObj, priceFields.discounted),//empty object if there are no discounts
    isTrial: !!product.is_trial && !!product.trial_duration_qty && !!product.trial_duration_span,
    trialDuration: product.trial_duration_qty,  // only the duration but based on span! ex: 1 quarter if qty 1 and span Q, or 3 months if qty 3 and span M
    trialDurationSpan: productAttributes['trial_duration_span'][product.trial_duration_span], // M, Q , Y
    trialPrice: product.trial_price,
    forceShowTrialInEachPriceSection: !!product.force_show_trial_price,
    autoRenew: product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO,
    inStock: product.stock_status == IN_STOCK,
    optionsToSelect: getOptionsForSelections(product),
    mediaGallery: product.media_gallery,
    paymentFrequenciesUids,
    hasPaperToAdd: modulesData.hasPaperToAdd,
    paperOptions,
    modulesInCartQty: modulesData.modulesInCartQty,
    modules: modulesData.modules,
    requiredModules: modulesData.requiredModules,
    hasDigitalSole24H: modulesData.hasDigitalSole24H,
    productTypeId: product.type_id,
    attributeSetName: attributeSets[product.attribute_set_id],
    categories: product.categories,
    typeId: product.type_id,
    variants: product.variants,
    configurable_options: formatConfigurableOptions(product.configurable_options, product.variants),
    startupCost: product.startup_cost,
    customizable_options: product.options,
    viewDiscountedPrice: product.view_discounted_price,
    discountedPriceEdicola: product.discounted_price_edicola,
    discountedPricePosta: product.discounted_price_posta,
    cancellation_notice_days: product.cancellation_notice_days,
    entryBillingPeriod: entryBillingPeriodValue,
    no_bzt_export: !!product.no_bzt_export,
    zuora_completed: !!product.zuora_completed,
    fulfillment_enabled: !!product.fulfillment_enabled,
    buyable: !product.not_ecommerce_buyable,
    coverPrice: product.cover_price,
    pdfPrice: product.pdf_price,
    published: product.data_pubblicazione,
    pages: product.numero_pagine,
    autore: product.autori,
    upSell: product.upsell_products,
    box_description: product.box_description ?? product.short_description?.html,
    boxImage: product.thumbnail ? product.thumbnail : product.image,
    agentFormLink: product.agent_form_link,
    productSite: product.product_site,
    description: product.description,
    shortDescription: product.short_description,
    area_funzionalita: product.area_funzionalita,
    area_cta: product.area_cta,
    area_bottom: product.area_bottom,
    support_contacts: product.support_contacts,
    area_principale: product.area_principale,
    tag_collana: product.tag_collana,
    collana_name: product.collana_name,
    suggested_sku: product.suggested_sku,
    plans_benchmark: product.plans_benchmark,
    tipo_rinnovo: product.tipo_rinnovo,
    card_subtitle: product.card_subtitle,
    renewal_cancellation_info: product.renewal_cancellation_info,
    freeDemoURL: product.free_demo,
    demoDuration: product.free_demo_duration,
    demoDurationSpan: product.free_demo_span,
    additionalSkus: product.offer_skus ?? "",
    moreInfoLabel: product.more_info_label,
    externalBuyLink: product.external_buy_link,
    customCssClasses: product.custom_css_classes,
    directCheckoutLabel: product.direct_checkout_label,
    canAddMultipleSubproducts: product.multiple_add_to_cart,
    codice_isbn: product?.codice_isbn,
    codice_isbn_digitale: product?.codice_isbn_digitale,
    offer_groups: offerGroups,
    meta_description: product.meta_description,
    meta_keyword: product.meta_keyword,
    url_key: product.url_key,
    meta_title: product.meta_title,
    url_suffix: product.url_suffix,
    more_cards_skus: product.more_cards_skus,
    ...extendedDatas ?? {}
  };
}

export const getGroupInfos = (group, productsInfos) => {
  let products = group.skus.split(',').map(sku => {
    const p = productsInfos[sku];
    if (!p) return; /** check di sicurezza, se per qualche motivo la graphql non torna un prodotto (magari per misconfigurazione della visibility, non andiamo in errore, ma ignoriamo quello sku) */
    /** Per ogni prodotto individuare se è configurabile e in tal caso splittarlo in varianti */
    if (p.typeId === CONFIGURABLE_TYPE_ID && p.configurable_options.every(el => el.attribute_code != 'tipo_abbonamento' && el.attribute_code != 'tipo_consegna')) {
      return p.variants.map(v => { return { ...p, currentVariant: v.product } })
    } else {
      return p
    }
  }).flat().filter(el => !!el)
  return { ...group, products }
}

export const getComponent = (item, optionsBlock, PurchaseOptionCard, BundlePurchaseOptionCard) => {
  if (item.typeId == CONFIGURABLE_TYPE_ID) {
      if (item.configurable_options.find(el => el.attribute_code != 'tipo_abbonamento')) {
          optionsBlock.value[item.sku] = getOptionsBlock(item)
      }
      return PurchaseOptionCard

  } else {
      return BundlePurchaseOptionCard

  }
}

export const getPosterImage = async (videoUrl) => {
  if (videoUrl.includes('brightcove')) {
        const BRIGHTCOVE_ACCOUNT_ID = videoUrl.split('players.brightcove.net/')[1].split('/default_default')[0]
        const VIDEO_ID = videoUrl.split('?videoId=')[1];
        const apiUrl = `https://edge.api.brightcove.com/playback/v1/accounts/${BRIGHTCOVE_ACCOUNT_ID}/videos/${VIDEO_ID}`;
        const videoDatas = await fetch(apiUrl, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json;pk='+BRIGHTCOVE_POLICY_KEY
            
          }
          
        }).then(response => {
          return response.json()
        }).catch(er => {
          console.log('Error fetching brightcove video data for poster image', er)
          return {}
        })
        return videoDatas
  }
}

/**
 * Function to get the product markup.
 * @param product
 * @param breadcrumbs
 * @param config
 * @returns 
 */
export const getProductMarkup = async (product, breadcrumbs, config, placeholderImage) => {
  if (!product || !config) return null

  const productMarkup: any = [];
  try {
    const productImages = (product.mediaGallery || [])
      .filter(img => !img.video_content && img.disabled === false)
      .map(img => img.url)
  
    const productVideos = (product.mediaGallery || [])
      .filter(img => img.video_content && img.disabled === false)
  
  
    if (productImages.length == 0 && productVideos.length == 0) {
          productImages.push(placeholderImage);
    } else if (productVideos.length > 0 && productImages.length == 0) {
      const vid = productVideos[0];
      
      const videoUrl = vid.video_content.video_url;
      const videoDatas = await getPosterImage(videoUrl)
      if (videoDatas?.poster) {
        productImages.push(videoDatas.poster)
      } else if (vid.url) {
        productImages.push(vid.url);
      } else {
        productImages.push(placeholderImage);
      }
    }
     const h1Value = product.collana_name ? `${product.collana_name} - ${product.name}` : product.name
    const BreadcrumbsItems = (breadcrumbs as any).map((breadcrumb: any, index: number) => {
      return {
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@id": breadcrumb.link,
          "name": breadcrumb.text
        }
      }
    });
    BreadcrumbsItems.push(
          {
            "@type":"ListItem",
            "position":4,
            "item":{
              "name":h1Value,
            }
        })
  
    /**
     * @todo: Add offers, because the product could have different periods and promos during the year.
     * So is better to decide with them how to handle this one.
     */
  
    const hasSomeBuyable = product.additionalProducts && product.additionalProducts.length > 0 && product.additionalProducts.some(p => p.buyable);
    const isNotBuyable = (hasSomeBuyable || product.agentFormLink || product.agentFormLink || product.freeDemoURL);
    const { lowestVariantPrice = null } = getLowestPricedVariant(product) || {};
    const lowestParentPrice = getLowestParentPrice(product, product.paymentFrequencies[0]);
  
    let lowestProduct = null;
    let offers = null;
  
    if (!isEmpty(product.additionalProducts)) {
  
      lowestProduct = getLowestMetaPrice(product.additionalProducts);
      const { lowestVariantPrice = null } = getLowestPricedVariant(lowestProduct) || {};
      const lowestParentPrice = getLowestParentPrice(lowestProduct, lowestProduct.paymentFrequencies[0]);
  
      if (lowestVariantPrice) {
        offers = {
          "offerCount": product.additionalProducts.length,
          "@type": "AggregateOffer",
          "lowPrice": lowestVariantPrice,
          "availability": "https://schema.org/InStock",
          "priceCurrency": "EUR"
        }
      }
  
      if (lowestParentPrice) {
        offers = {
          "offerCount": product.additionalProducts.length,
          "@type": "AggregateOffer",
          "lowPrice": lowestParentPrice,
          "availability": "https://schema.org/InStock",
          "priceCurrency": "EUR"
        }
      }
  
    }
  
    if (lowestVariantPrice) {
      offers = {
        "offerCount": product.variants.length,
        "@type": "AggregateOffer",
        "lowPrice": lowestVariantPrice,
        "availability": "https://schema.org/InStock",
        "priceCurrency": "EUR"
      }
    }
  
    if (lowestParentPrice) {
      offers = {
        "@type": "Offer",
        "price": lowestParentPrice,
        "priceCurrency": "EUR",
        "availability": "https://schema.org/InStock"
      }
    }
  
  
  
    if (breadcrumbs.length > 0) {
      productMarkup.push({
        hid: 'ld-breadcrumbs',
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": BreadcrumbsItems || []
        }
      })
    }
  
    /**
     * @todo: We don't have video upload date.
     */
  
    if (productVideos.length > 0) {
      productMarkup.push({
        hid: 'ld-video',
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": product.name || '',
          "description": product.subtitle || product.description || '',
          "thumbnailUrl": productImages[0] || productVideos[0].url,
          "uploadDate": "2025-06-30T09:00:00+08:00", // Hardcoded, because magento side this date is not dynamic, before, we should fix it BE.
          "contentUrl": productVideos[0].video_content.video_url,
          "embedUrl": `${config.soleproDomain}/24orepro/${product.url_key}.html`
        }
      })
    }
  
    if (!offers) return productMarkup;
  
    if (
      hasSomeBuyable ||
      (!hasSomeBuyable && !isNotBuyable)
    ) {
      productMarkup.push({
        hid: 'ld-product',
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org/",
          "@type": "Product",
          name: product.name || '',
          url: `${config.soleproDomain}/24orepro/${product.url_key}.html` || '',
          image: productImages,
          description: product.subtitle || product.description || '',
          offers: offers
        }
      })
    }
  } catch (e) {
    console.error(`Error getting product ( sku: ${product.sku} ) markup`, e)
  }

  return productMarkup;
}
